import React, { useState, useEffect } from "react";
import { Accordion, Button, Col, Row, Alert, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomToast from "../../components/common/CustomToast";
import {
  productResetById,
  productResetBySku,
  categoriesReset,
  resetProductStatusAfterDelay,
} from "../../store/slices/linkReset";

const LinkReset = () => {
  const [resetData, setResetData] = useState([]);
  const [resetFlag, setResetFlag] = useState("");
  const [toastStatus, setToastStatus] = useState(null);
  const [toastBody, setToastBody] = useState(null);
  const { targetStoreHash } = useSelector((state) => state.productMapping);
  const { clientStoreHash, data } = useSelector((state) => state.config);
  const {
    productReset,
    categoryReset,
    productSyncSuccess,
    categorySyncSuccess,
  } = useSelector((state) => state.linkReset);
  const dispatch = useDispatch();

  const handleProductReset = (e) => {
    e.preventDefault();
    if (
      data?.attributeMapping &&
      resetData.length > 0 &&
      (targetStoreHash !== null || clientStoreHash !== null)
    ) {
      let request = {
        dataList: resetData,
        storeDomain:
          targetStoreHash !== null ? targetStoreHash : clientStoreHash,
      };
      if (resetFlag === "sku" && resetFlag !== "") {
        dispatch(productResetBySku(request));
      } else if (resetFlag === "id" && resetFlag !== "") {
        dispatch(productResetById(request));
      }
    }
  };

  const handleCategoryReset = (e) => {
    e.preventDefault();
    if (targetStoreHash !== null || clientStoreHash !== null) {
      let request = {
        storeDomain:
          targetStoreHash !== null ? targetStoreHash : clientStoreHash,
      };
      dispatch(categoriesReset(request));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name !== "userInput") {
      setResetFlag(value);
    } else {
      let newValues = value.split(",");
      setResetData(newValues);
    }
  };

  useEffect(() => {
    if (productReset === "completed") {
      setToastStatus("success");
      setToastBody("Product refresh successful")
      dispatch(resetProductStatusAfterDelay());
    }else if(categoryReset === "completed"){
      setToastStatus("success");
      setToastBody("categories refresh successful")
    }else if(productReset === "failed"){
      setToastStatus("failed");
      setToastBody("Product refresh failed");
    }else if(categoryReset === "failed"){
      setToastStatus("failed");
      setToastBody("category refresh failed");
    }
  }, [productReset,categoryReset, dispatch]);

  return (
    <>
      {/* <Alert variant="info" className="mt-4">
        <p className="mb-2">
          Enter a Product ID and hit <strong>Reset Product Link</strong> and it
          will delete a product in Shopify.
        </p>
        <p className="mb-2">
          Enter a Category ID (i.e. Collection) in Shopify and hit{" "}
          <strong>Reset Category Link</strong> and it will delete a category in
          Shopify.
        </p>
        <p className="mb-0">
          This will ensure the product or category can be synced from Akeneo to
          Shopify without errors.
        </p>
      </Alert> */}

      <Accordion className="mt-3" defaultActiveKey={["0"]} alwaysOpen>
        {(productReset === "completed" || productReset === "failed") ? (
          <CustomToast
            status={toastStatus}
            body={toastBody}
            setStatus={setToastStatus}
          />
        ): (categoryReset === "completed" || categoryReset === "failed") && (
          <CustomToast
            status={toastStatus}
            body={toastBody}
            setStatus={setToastStatus}
          />
        )}
        <Accordion.Item eventKey="0" className="my-4">
          <Accordion.Header className="h5 fw-bold">
            Product Reset
          </Accordion.Header>
          <Accordion.Body className="px-4 py-2">
            <Form onSubmit={handleProductReset}>
              <Row>
                <Col sm={12}>
                  <div key="radio" className="mb-3">
                    <Form.Check
                      inline
                      label="Refresh by SKU"
                      name="reset"
                      value="sku"
                      onChange={handleChange}
                      className="reset-radio"
                      type="radio"
                      required
                      id={`inline-radio-1`}
                    />
                    <Form.Check
                      inline
                      label="Refresh by Shopify GID"
                      name="reset"
                      value="id"
                      onChange={handleChange}
                      type="radio"
                      className="reset-radio"
                      required
                      id={`inline-radio-2`}
                    />
                  </div>
                  <Form.Group controlId="productId">
                    <Form.Control
                      as="textarea"
                      type="text"
                      className="mb-3"
                      name="userInput"
                      // onChange={handleChange}
                      placeholder="Enter the SKU or Shopify ID (Comma separated)"
                      value={resetData}
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Col>
                <Col sm={12}>
                  <Button
                    variant="primary"
                    type="submit"
                    className="stru-btn mb-3"
                  >
                    {productReset === "inprogress" && (

                      <div
                        className="spinner-border me-2"
                        role="status"
                        style={{ width: "18px", height: "18px" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                    Reset Product Link
                  </Button>
                </Col>
              </Row>
            </Form>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default LinkReset;
